import Component from "./component.js";
import "./styles.scss";
export default Component;
